import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { useConversion, useStandards } from 'hooks';
import Widget from 'components/Widget';
import { AgpProfileChart } from 'modules/AmbulatoryGlucoseProfile';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import messages from '../../messages';
import styles from '../Results/Results.pcss';
const AgpTrendChartWidget = ({ statsData, start, end, className, isInProgress, onDatesChange })=>{
    const mode = useSelector(selectors.mode);
    const conversion = useConversion('bloodGlucoseConcentration');
    const standards = useStandards(true);
    return /*#__PURE__*/ _jsx(Widget, {
        widgetId: constants.AGP_TREND_CHART_WIDGET,
        headerMessage: statsData.length >= constants.READING_COUNT_TO_SHOW_AGP_BGM ? messages.headers.ambulatoryGlucoseProfile : messages.headers.modalDay,
        className: cn(className, 'mb-1'),
        children: /*#__PURE__*/ _jsx("div", {
            className: styles.wrapper,
            children: /*#__PURE__*/ _jsx(AgpProfileChart, {
                conversion: conversion,
                standards: standards,
                mode: mode,
                start: start,
                end: end,
                onDatesChange: onDatesChange,
                data: statsData,
                isInProgress: isInProgress
            })
        })
    });
};
export default AgpTrendChartWidget;
